export default "__VITE_ASSET__082e9270__"